(() => {
  if (window.ffCollectionCardsReady) return;
  window.ffCollectionCardsReady = true;

  const syncWishlistVariant = (card, variantId) => {
    const placeholder = card.querySelector('.gw-add-to-wishlist-product-card-placeholder');
    if (!placeholder || !variantId) return;
    const currentVariant = placeholder.getAttribute('data-gw-variant-id');
    const exactVariant = placeholder.getAttribute('data-gw-exact-variant-id') === 'true';
    if (currentVariant === String(variantId) && exactVariant) return;
    const next = document.createElement('div');
    next.className = 'gw-add-to-wishlist-product-card-placeholder';
    next.setAttribute('data-gw-product-id', placeholder.getAttribute('data-gw-product-id') || '');
    next.setAttribute('data-gw-variant-id', String(variantId));
    next.setAttribute('data-gw-exact-variant-id', 'true');
    next.setAttribute('data-gw-widget-position', 'right');
    next.style.display = 'block';
    placeholder.replaceWith(next);
  };

  const replaceMoney = (container, value) => {
    if (!container) return;
    if (!value) {
      container.replaceChildren();
      return;
    }
    const money = document.createElement('span');
    money.className = 'money';
    money.textContent = value;
    container.replaceChildren(money);
  };

  const syncVariant = (card, select) => {
    const option = select.selectedOptions[0];
    if (!option) return;
    const data = option.dataset;
    const available = data.available === 'true';
    const button = card.querySelector('[data-ffc-add]');
    const current = card.querySelector('[data-ffc-price]');
    const compare = card.querySelector('[data-ffc-compare]');
    const compareWrap = card.querySelector('[data-ffc-compare-wrap]');
    const sale = card.querySelector('[data-ffp-sale]');
    const sold = card.querySelector('[data-ffc-sold]');
    const image = card.querySelector('.ffc-card__photo');

    replaceMoney(current, data.price);
    replaceMoney(compare, data.compare);
    if (compareWrap) compareWrap.hidden = !data.compare;
    if (sale) {
      sale.hidden = !data.saving;
      const discount = sale.querySelector('[data-ffp-discount]');
      if (discount) discount.textContent = data.saving || '0';
    }
    if (sold) sold.hidden = available;
    if (button && button.getAttribute('aria-busy') !== 'true') {
      button.disabled = !available;
      button.classList.toggle('is-soldout', !available);
      const label = button.querySelector('.text');
      if (label) label.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
    }
    if (image && data.image && image.getAttribute('src') !== data.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = data.image;
      image.alt = data.imageAlt || card.dataset.productTitle || '';
    }
    if (data.url) {
      card.dataset.productUrl = data.url;
      card.querySelectorAll('[data-ffc-product-link]').forEach(link => { link.href = data.url; });
    }
    if (data.image) card.dataset.productImage = data.image;
    syncWishlistVariant(card, option.value);
    if (typeof window.baCurr?.refreshConversion === 'function') {
      try {
        window.baCurr.refreshConversion();
      } catch (error) {
        console.warn('Collection currency refresh failed', error);
      }
    }
  };

  const setup = (scope = document) => {
    scope.querySelectorAll('.ffc-card').forEach(card => {
      if (card.dataset.ffcReady) return;
      card.dataset.ffcReady = 'true';
      const select = card.querySelector('[data-ffc-variant]');
      const button = card.querySelector('[data-ffc-add]');
      syncWishlistVariant(card, card.querySelector('[name="id"]')?.value);
      if (!select || !button) return;
      select.addEventListener('change', () => syncVariant(card, select));
      const busyObserver = new MutationObserver(() => {
        const busy = button.getAttribute('aria-busy') === 'true';
        select.disabled = busy;
        if (!busy) syncVariant(card, select);
      });
      busyObserver.observe(button, { attributes: true, attributeFilter: ['aria-busy'] });
      card.addEventListener('ffc:dispose', () => busyObserver.disconnect(), { once: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup(), { once: true });
  else setup();
  document.addEventListener('shopify:section:load', event => setup(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ffc-card').forEach(card => card.dispatchEvent(new Event('ffc:dispose')));
  });
  document.addEventListener('ffc:products-updated', event => setup(event.target));
})();
